import { render, staticRenderFns } from "./ContactListCreateOrEdit.vue?vue&type=template&id=72439c7e&"
import script from "./ContactListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./ContactListCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactListCreateOrEdit.vue?vue&type=style&index=0&id=72439c7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports